// extracted by mini-css-extract-plugin
export default {"unauthorized":"UnauthorizedPage_unauthorized__jfOed","description":"UnauthorizedPage_description__xTh6+"};